import { render, staticRenderFns } from "./aboutpopup.vue?vue&type=template&id=697afb8e&scoped=true&"
import script from "./aboutpopup.vue?vue&type=script&lang=js&"
export * from "./aboutpopup.vue?vue&type=script&lang=js&"
import style0 from "./aboutpopup.vue?vue&type=style&index=0&id=697afb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697afb8e",
  null
  
)

export default component.exports